import React, { useState } from "react";
import logo from "../assets/app_logo.png";
import { useParams } from "react-router-dom";
const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { videoId } = useParams();
  console.log(videoId);
  return (
    <header className="bg-black text-white">
      <div className="container mx-auto flex items-center justify-between sm:justify-between lg:justify-start md:justify-between p-4">
        {/* Logo */}
        <>
          <a href="">
            <img src={logo} className="w-3/5 h-auto" />
          </a>
        </>

        {/* Desktop Menu */}
        <nav className="hidden md:flex space-x-6 pt-1 items-center justify-between"></nav>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            />
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-black p-4"></div>}
    </header>
  );
};

export default Header;
